import React from "react";
import "./pages.css";
import "./pagesResponsiveStylesheet.css";
import HeadSection from "../Components/HeadSection/HeadSection";
import Icon from "../Assets/IconLibrary/Icon";
import {BusinessFunctionList} from "../Assets/Contents/DummyStructure/BusinessFunction";
import {IndustrySolutionList} from "../Assets/Contents/IndustrySolution";
import {MyTooltip} from "../Components/Tooltip/Tooltip";
import Popup from "reactjs-popup";

export default class Solution extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showAllIndustry: false,
            tabList: [
                {Label: "IT", Value: "it"},
                {Label: "Business Functions", Value: "business-function"},
                {Label: "Industries", Value: "industries"},

            ],
            solutionLoaded: true,
            chosenTab: "Solution",
            businessFunctionList: BusinessFunctionList,
            chosenFunctionTab: "Marketing",

            industrySolutionList: IndustrySolutionList,
            industryList: [
                {
                    "ID": "7446f5ac-1e5f-4ec3-937d-546777388279",
                    "Industry": "Financial",
                    "Icon": "financial",
                    "Illustration": "",
                    "Title": "",
                    "BriefDescription": "",
                    "Info": null
                },
                {
                    "ID": "6646f5ac-1e5f-4ec3-937d-546777388279",
                    "Industry": "Healthcare",
                    "Icon": "health_care",
                    "Illustration": "",
                    "Title": "",
                    "BriefDescription": "",
                    "Info": null
                },
            ],

            chosenIndustry: "Financial",
            showMobileIndustryContent: true,

            ipSolutionList: [
                {
                    Name: "Benchmarking",
                    Icon: "Benchmarking",
                    Description: [
                        "Benchmarking your patent portfolio against industry standards and competitors is essential for evaluating performance and strategic positioning. AnyGen’s GenAI platform offers advanced benchmarking tools that provide detailed comparisons and performance metrics. This enables organizations to identify areas for improvement, refine their IP strategies, and make informed decisions that enhance their competitive stance. By leveraging these insights, businesses can ensure their patent portfolios are optimized for success, aligned with market trends, and strategically positioned to drive innovation and growth."
                    ]
                },
                {
                    Name: "Competitive Intelligence and Benchmarking",
                    Icon: "Competitive_Intelligence_and_Benchmarking",
                    Description: [
                        "Understanding your competitors' strategies is crucial for maintaining a competitive edge. By analyzing competitors' patent portfolios, companies can gain insights into their R&D focuses and technological strengths. This analysis helps in identifying gaps within your own portfolio and developing smarter filing strategies. AnyGen’s GenAI platform enhances this process by automating data analysis, transforming complex datasets into clear, actionable insights. This allows businesses to make informed decisions, stay ahead in the market, and uncover valuable collaboration opportunities, ensuring a strategic advantage in innovation and development."
                    ]
                },
                {
                    Name: "Disruptive Technology Scouting",
                    Icon: "Disruptive_Technology_Scouting",
                    Description: [
                        "Staying ahead of technological advancements is key to maintaining market leadership. Disruptive technology scouting involves identifying emerging technologies that have the potential to reshape industries. AnyGen’s GenAI platform excels at monitoring the innovation landscape, analyzing large datasets to predict technological trends and identify promising innovations. This proactive approach allows businesses to adapt quickly, invest wisely, and maintain a competitive edge. By providing detailed insights into new technologies, AnyGen enables organizations to strategically align their R&D efforts and capitalize on future opportunities."
                    ]
                },
                {
                    Name: "Licensing & SEPs Identification",
                    Icon: "Licensing_SEPs_Identification",
                    Description: [
                        "Optimizing IP revenue through licensing requires identifying valuable patents and potential Standard Essential Patents (SEPs). This involves assessing patents' market relevance and their essentiality to industry standards. AnyGen’s GenAI platform automates this evaluation, providing reliable data and insights to support strategic licensing decisions. By identifying high-value patents and potential SEPs, businesses can enhance their licensing strategies and maximize IP revenue streams. This strategic approach ensures that organizations capitalize on valuable opportunities and optimize the commercial potential of their patent portfolios."
                    ]
                },
                {
                    Name: "Patent Essentiality Determination",
                    Icon: "Patent_Essentiality_Determination",
                    Description: [
                        "Determining the essentiality of patents to industry standards is crucial for understanding their value and importance. This process involves accessing examiner statistics and evaluating how critical a patent is to a given standard. AnyGen’s GenAI platform facilitates this by providing direct access to reliable examiner statistics from authoritative sources, ensuring accurate assessments of patent essentiality. This capability helps organizations make informed decisions about their IP strategies, focusing on patents that are most valuable and relevant to their technological and business objectives."
                    ]
                },
                {
                    Name: "Portfolio Management & Optimization",
                    Icon: "Portfolio_Management_and_Optimization",
                    Description: [
                        "Maximizing the value of your patent portfolio requires a detailed understanding of your assets and their market positioning. Portfolio management involves comparing your patents with competitors', identifying strengths, weaknesses, and opportunities. AnyGen's GenAI platform provides real-time data and strategic insights to refine filing and pruning strategies. By automating these complex analyses, AnyGen helps ensure that your investments are directed towards high-value patents, enhancing the relevance and impact of your portfolio. This strategic alignment with business objectives supports robust portfolio management and drives competitive advantage."
                    ]
                },

                {
                    Name: "R&D and Innovation Monitoring",
                    Icon: "R_D_and_Innovation_Monitoring",
                    Description: [
                        "Keeping abreast of innovation trends and R&D activities is essential for fostering continuous growth. This involves tracking key players, emerging trends, and potential growth areas in the market. AnyGen’s GenAI platform offers comprehensive monitoring and analysis, providing real-time insights into competitors' activities and industry developments. This information supports effective R&D planning, ensuring that innovation strategies are aligned with market demands. By leveraging these insights, businesses can drive innovation, make informed decisions, and maintain a strong market presence.",
                    ]
                },
                {
                    Name: "Risk Assessment",
                    Icon: "Risk_Assessment",
                    Description: [
                        "Effectively managing risks associated with your patent portfolio is critical for maintaining its value. Risk assessment involves identifying litigation risks, potential infringements, and patent expirations. AnyGen's GenAI platform offers comprehensive tools for risk analysis, providing detailed, actionable insights that help organizations proactively manage these risks. By automating the identification and evaluation of potential threats, AnyGen enables businesses to mitigate risks effectively and ensure the robustness of their patent portfolios. This proactive approach safeguards intellectual property and supports long-term business success.",
                    ]
                },




                {
                    Name: "SDG Goals Tracking",
                    Icon: "SDG_Goals_Tracking",
                    Description: [
                        "Aligning your innovation efforts with Sustainable Development Goals (SDGs) is vital for contributing to global sustainability. This process involves evaluating patents that support specific SDGs and understanding which companies are investing in these areas. AnyGen's GenAI platform provides detailed insights into how patents align with SDGs, helping organizations assess their contributions to sustainability. By integrating SDG tracking into their IP strategy, businesses can make informed decisions about R&D investments and partnerships, ensuring their innovations support broader societal goals and contribute to sustainable development."
                    ]
                },
            ],
            activeIPSolutionTab: "Benchmarking",
            solutionTabList: [
                {Name: "IP Solutions"},
                {Name: "Other Solutions"},
            ],
            activeSolutionTab: "IP Solutions",
            ipSolutionTooltip: false,
            openIPSolutionDetailPopup: false,
            activeIPSolution: 0,

        }
    }

    openIPSolutionDetails = (id) => {
        this.setState({
            activeIPSolution: id,
            openIPSolutionDetailPopup: true
        })
    }

    openIndustryDetailedInfo = (activeIndustry) => {
        let {chosenIndustry, showMobileIndustryContent} = this.state;

        if (chosenIndustry === activeIndustry) {
            showMobileIndustryContent = !this.state.showMobileIndustryContent;
            this.setState({
                chosenIndustry: activeIndustry,
                showMobileIndustryContent
            })
        } else {
            this.setState({
                chosenIndustry: activeIndustry,
                showMobileIndustryContent: true
            })
        }

    }


    getIPSolutionDetail = (info, pageType) => {
        return (
            info !== null && info !== undefined ?
                <div className="ip-solution-detail-popup">
                    <div className="profile-detail-info-border">

                    </div>
                    {
                        pageType === "mobile"?
                            <button className="ip-solution-detail-detail-close-btn" onClick={()=>this.setState({openIPSolutionDetailPopup: false})}>
                                X
                            </button>
                            :
                            null
                    }


                    <div className="ip-solution-detail-header">
                        <div className="ip-solution-detail-icon">
                            <Icon name={info.Icon} size={50}/>
                        </div>
                        <div className="default-header-style ip-solution-detail-name">{info.Name}</div>
                    </div>
                    <div className="ip-solution-detail-body">
                        {
                            info.Description !== null && info.Description !== undefined &&
                            info.Description.map((res, index) =>
                                res
                            )
                        }
                    </div>
                </div>
                :
                null
        )
    }


    render() {
        let {showMobileIndustryContent} = this.state;
        return (
            <div className="solution-layout">
                <HeadSection keyword={"solution"}/>
                <div className="solution-layout-main-tab-bar">
                    {
                        this.state.solutionTabList.map((res, index) =>
                            res.Name === this.state.activeSolutionTab ?
                                <div className="solution-layout-main-tab active">
                                    {res.Name}
                                    <div className="solution-layout-main-tab-bottom-border"/>
                                </div>
                                :
                                <div className="solution-layout-main-tab" onClick={() => {
                                    this.setState({activeSolutionTab: res.Name})
                                }}>
                                    {res.Name}
                                </div>
                        )
                    }
                </div>

                {
                    this.state.activeSolutionTab === "Other Solutions" ?
                        <>
                            <div className="solution-main-body">

                                <div className="solution-main-layout--left">
                                    <div className="solution-main-layout--inner">
                                        <h3 className="default-header-style solution-main-layout-left-title">
                                            Industries</h3>
                                        <div className="solution-industry-list">
                                            {
                                                this.state.industryList.map((res, index) =>
                                                    <div
                                                        className={res.Industry === this.state.chosenIndustry ? "solution-tab active" : "solution-tab"}
                                                        onClick={() => this.setState({chosenIndustry: res.Industry})}>
                                                        <Icon name={res.Icon} size={20} colorList={["white", "white"]}/>
                                                        {res.Industry}
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                                {
                                    this.state.chosenIndustry === "Financial" ?
                                        <div className="solution-main-layout--right">
                                            <h2 className="default-header-style solution-title">
                                                Generative AI in Finance
                                            </h2>
                                            <div className="solution-description">
                                                <p>
                                                    Executives and Developers across banking, capital markets,
                                                    insurance, payments are waiting in the wings to leverage the power
                                                    of generative ai in a way that seamlessly integrates with their
                                                    workflows. AnyGen AI supports any and all the financial use cases
                                                    enterprises wants to solve today:
                                                </p>
                                                <ul>
                                                    <li>
                                                        Conversational finance
                                                        <ul>
                                                            <li>Improve customer experience</li>
                                                            <li>Personalized financial advice</li>
                                                            <li>Payment notifications</li>
                                                        </ul>
                                                    </li>

                                                    <li>Automation of accounting functions</li>
                                                    <li>Automation of business processes</li>
                                                    <li>Increase productivity of knowledge workers</li>
                                                    <li>Understand market and customer sentiment</li>
                                                    <li>Drive product innovation</li>

                                                </ul>
                                            </div>

                                        </div>
                                        :
                                        <div className="solution-main-layout--right">
                                            <h2 className="default-header-style solution-title">

                                                Generative AI in Healthcare
                                            </h2>
                                            <div className="solution-description">
                                                <p>
                                                    Healthcare data is mostly unstructured and collected in the
                                                    hospitals and enterprises have complex challenges in bringing the
                                                    data to usable form and then mine for intelligence. Generative AI is
                                                    revolutionizing many use cases in healthcare that were very hard to
                                                    solve before - AnyGen, with its comprehensive Gen AI capabilities
                                                    enables enterprises with
                                                </p>
                                                <ul>
                                                    <li>Drug Discovery</li>
                                                    <li>Operational Efficiencies</li>
                                                    <li>Personalized Care</li>

                                                </ul>
                                            </div>

                                        </div>

                                }

                            </div>

                            <div className="solution-main-mobile-body">
                                <div className="solution-list">
                                    {
                                        this.state.industryList.map((industry, id) =>
                                            <div className="solution-industry-card"
                                                 onClick={this.openIndustryDetailedInfo.bind(this, industry.Industry)}>
                                                <div className="solution-industry-card--header">
                                                    <div
                                                        className="default-header-style solution-industry-card--header--left">
                                                        {industry.Industry}
                                                    </div>
                                                    <div className="solution-industry-card--header--right">
                                                        <button
                                                            className={this.state.chosenIndustry === industry.Industry && showMobileIndustryContent ? "solution-industry-card-drop-down-btn expand" : "solution-industry-card-drop-down-btn"}>
                                                            <Icon name={"drop_down"} size={14}/>
                                                        </button>
                                                    </div>
                                                </div>
                                                {
                                                    this.state.chosenIndustry === industry.Industry && showMobileIndustryContent &&
                                                    <div className="solution-industry-card--body">
                                                        {
                                                            this.state.chosenIndustry === "Financial" ?
                                                                <div className="solution-industry-card-content">
                                                                    <div className="solution-title">
                                                                        Generative AI in Finance
                                                                    </div>
                                                                    <div className="solution-description">
                                                                        <p>
                                                                            Executives and Developers across banking,
                                                                            capital markets, insurance, payments are
                                                                            waiting in the wings to leverage the power
                                                                            of generative ai in a way that seamlessly
                                                                            integrates with their workflows. AnyGen AI
                                                                            supports any and all the financial use cases
                                                                            enterprises wants to solve today:
                                                                        </p>
                                                                        <ul>
                                                                            <li>
                                                                                Conversational finance
                                                                                <ul>
                                                                                    <li>Improve customer experience</li>
                                                                                    <li>Personalized financial advice
                                                                                    </li>
                                                                                    <li>Payment notifications</li>
                                                                                </ul>
                                                                            </li>

                                                                            <li>Automation of accounting functions</li>
                                                                            <li>Automation of business processes</li>
                                                                            <li>Increase productivity of knowledge
                                                                                workers
                                                                            </li>
                                                                            <li>Understand market and customer
                                                                                sentiment
                                                                            </li>
                                                                            <li>Drive product innovation</li>

                                                                        </ul>
                                                                    </div>

                                                                </div>
                                                                :
                                                                <div className="solution-industry-card-content">
                                                                    <div className="solution-title">
                                                                        Generative AI in Healthcare
                                                                    </div>
                                                                    <div className="solution-description">
                                                                        <p>
                                                                            Healthcare data is mostly unstructured and
                                                                            collected in the hospitals and enterprises
                                                                            have complex challenges in bringing the data
                                                                            to usable form and then mine for
                                                                            intelligence. Generative AI is
                                                                            revolutionizing many use cases in healthcare
                                                                            that were very hard to solve before -
                                                                            AnyGen, with its comprehensive Gen AI
                                                                            capabilities enables enterprises with
                                                                        </p>
                                                                        <ul>
                                                                            <li>Drug Discovery</li>
                                                                            <li>Operational Efficiencies</li>
                                                                            <li>Personalized Care</li>

                                                                        </ul>
                                                                    </div>

                                                                </div>

                                                        }

                                                    </div>
                                                }

                                            </div>
                                        )
                                    }
                                </div>
                            </div>

                        </>
                        :
                        <>
                            <div className="solution-main-body">

                                <div className="ip-solution-layout">
                                    <div className="ip-solution-card-list">
                                        {
                                            this.state.ipSolutionList.map((res, index) =>
                                                <MyTooltip title={this.getIPSolutionDetail(res, "laptop")} maxWidth={"900px"}
                                                           openTooltip={this.state.ipSolutionTooltip}>
                                                    <div

                                                        className={res.Name === this.state.active ? "ip-solution-tab active" : "ip-solution-tab"}>
                                                        <svg className="ip-solution-hex" preserveAspectRatio={"none"}

                                                             width="450" height="450" viewBox="0 0 450 450" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                                  d="M225 0L0 114.561V337.5L225 450L450 337.5V113L225 0ZM4.19249 116.601L225 5L446 115.5V335L225 445L4 335L4.19249 116.601Z"
                                                                  fill="url(#paint0_linear_136_651)"/>
                                                            <defs>
                                                                <linearGradient id="paint0_linear_136_651" x1="113.862"
                                                                                y1="208.573" x2="433.093" y2="364.69"
                                                                                gradientUnits="userSpaceOnUse">
                                                                    <stop stop-color="#00E9C1"/>
                                                                    <stop offset="1" stop-color="#498CE4"/>
                                                                </linearGradient>
                                                            </defs>
                                                        </svg>
                                                        <div className="ip-solution-card-info">
                                                            <Icon name={res.Icon} fillRule={"evenodd"} size={40}
                                                                  className="ip-solution-card-icon"/>
                                                            <div className="ip-solution-card-name">
                                                                {res.Name}
                                                            </div>

                                                        </div>


                                                    </div>
                                                </MyTooltip>
                                            )
                                        }
                                    </div>
                                </div>

                            </div>


                            <div className="solution-main-mobile-body">
                                <div className="ip-solution-card-list">
                                    {
                                        this.state.ipSolutionList.map((res, index) =>
                                            <div
                                                onClick={this.openIPSolutionDetails.bind(this, res)}
                                                className={res.Name === this.state.active ? "ip-solution-tab active" : "ip-solution-tab"}>
                                                <svg className="ip-solution-hex" preserveAspectRatio={"none"}
                                                     width="450" height="450" viewBox="0 0 450 450" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                          d="M225 0L0 114.561V337.5L225 450L450 337.5V113L225 0ZM4.19249 116.601L225 5L446 115.5V335L225 445L4 335L4.19249 116.601Z"
                                                          fill="url(#paint0_linear_136_65)"/>
                                                    <defs>
                                                        <linearGradient id="paint0_linear_136_65" x1="113.862"
                                                                        y1="208.573" x2="433.093" y2="364.69"
                                                                        gradientUnits="userSpaceOnUse">
                                                            <stop stop-color="#00E9C1"/>
                                                            <stop offset="1" stop-color="#498CE4"/>
                                                        </linearGradient>
                                                    </defs>
                                                </svg>
                                                <div className="ip-solution-card-info">
                                                    <Icon name={res.Icon} size={40} className="ip-solution-card-icon"/>
                                                    <div className="ip-solution-card-name">
                                                        {res.Name}
                                                    </div>

                                                </div>


                                            </div>
                                        )
                                    }
                                </div>
                            </div>

                            <Popup contentStyle={{
                                background: "transparent",
                                border: "none",
                            }} open={this.state.openIPSolutionDetailPopup}
                                   onClose={()=>this.setState({openIPSolutionDetailPopup: false})}
                                   closeOnDocumentClick={true}
                                   lockScroll={false}>
                                {this.getIPSolutionDetail(this.state.activeIPSolution, "mobile")}

                            </Popup>

                        </>
                }


            </div>
        );
    }

}